import { render, staticRenderFns } from "./ListRemoteRequest.vue?vue&type=template&id=6509b3d9&scoped=true&"
import script from "./ListRemoteRequest.vue?vue&type=script&lang=js&"
export * from "./ListRemoteRequest.vue?vue&type=script&lang=js&"
import style0 from "./ListRemoteRequest.vue?vue&type=style&index=0&id=6509b3d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6509b3d9",
  null
  
)

export default component.exports